<script lang="ts">
	import { type TableOfContentsItem, type TableOfContentsElements } from '@melt-ui/svelte';
	import { createEventDispatcher } from 'svelte';

	export let tree: TableOfContentsItem[] = [];
	export let activeHeadingIdxs: number[];
	export let item: TableOfContentsElements['item'];
	export let level = 1;

	const dispatch = createEventDispatcher<{
		click: HTMLHeadingElement;
	}>();
</script>

<ul class="menu">
	{#if tree && tree.length}
		{#each tree as heading, i (i)}
			<li>
				<a
					href="#{heading.id}"
					{...$item(heading.id)}
					use:item
					on:click|preventDefault={() => dispatch('click', heading.node)}
				>
					{@html heading.node.innerHTML}
				</a>
				{#if heading.children && heading.children.length}
					<svelte:self
						tree={heading.children}
						level={level + 1}
						{activeHeadingIdxs}
						{item}
						on:click
					/>
				{/if}
			</li>
		{/each}
	{/if}
</ul>

<style lang="postcss">
	a {
		@apply font-medium;
		@apply opacity-100 transition-opacity duration-300;
		@apply hover:bg-transparent focus:bg-transparent hover:underline focus:underline;

		&:not([data-active]) {
			@apply opacity-70;
		}
	}
</style>
